import React from 'react'
import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import { useTabNavContext } from '../../utils/providers/tabNavContext'
import { useTabNavLink } from './TabNavLink'
import { headerSecondaryTabsSx, headerSecondaryTabSx } from './tabNavStyles'

const LayoutNavSecondary: React.FC = () => {
  const { secondaryItems } = useTabNavContext()
  const { currentRouteIndex, displayableItems } = useTabNavLink(secondaryItems, headerSecondaryTabSx)

  if (!displayableItems.length) return null

  return (
    <Box
      sx={{
        flex: 0,
        maxWidth: '100%',
        position: 'relative',
        '&::after': {
          backgroundColor: 'divider',
          bottom: 0,
          content: '""',
          height: '1px',
          left: 0,
          pointerEvents: 'none',
          position: 'absolute',
          right: 0,
          zIndex: 0,
        },
      }}
    >
      <Tabs
        value={currentRouteIndex}
        data-testid="subtabnavlink-tabs"
        scrollButtons="auto"
        variant="scrollable"
        sx={headerSecondaryTabsSx}
      >
        {displayableItems}
      </Tabs>
    </Box>
  )
}

export default LayoutNavSecondary
